<div class="container">
  <div class="header">
    <div class="customer-info page-header" i18n>Customer Information</div>
    <div class="customer-details-text page-content" i18n>
      We require some information about you. Please fill the details.
    </div>
    <div class="required-fields page-content" i18n>
      Fields marked <span class="star-icon page-content">*</span> are required
    </div>
  </div>

  <div class="container-body">
    <div class="details page-header" i18n>Personal Details</div>
    <form [formGroup]="customerInfoForm">
      <mat-form-field class="mb-3" appearance="outline"
        [ngClass]="customerInfoForm.get('name')?.invalid && customerInfoForm.get('name')?.touched ? 'required-field' : 'normal-field'">
        <mat-label i18n>Name</mat-label>
        <input matInput formControlName="name" [placeholder]="customerName">
        <mat-error>
          {{ validationMessages.name.required }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="mb-3" appearance="outline"
        [ngClass]="customerInfoForm.get('phoneNo')?.invalid && customerInfoForm.get('phoneNo')?.touched ? 'required-field' : 'normal-field'">
        <mat-label i18n>Phone No.</mat-label>
        <input matInput formControlName="phoneNo" [placeholder]="phoneNumber" type="text" maxlength="15">
        @if (customerInfoForm.get('phoneNo')?.hasError('maxlength')) {
        <mat-error>
          {{ validationMessages.phoneNo.maxlength }}
        </mat-error>
        }
        <mat-error>
          {{ customerInfoForm.get('phoneNo')?.hasError('required')
          ? validationMessages.phoneNo.required
          : validationMessages.phoneNo.pattern }}
        </mat-error>
      </mat-form-field>


      <mat-form-field class="mb-3" appearance="outline"
        [ngClass]="customerInfoForm.get('email')?.invalid && customerInfoForm.get('email')?.touched ? 'required-field' : 'normal-field'">
        <mat-label i18n>Mail</mat-label>
        <input matInput type="email" formControlName="email" [placeholder]="emailAddress">
        <mat-error>
          {{ customerInfoForm.get('email')?.hasError('required') ? validationMessages.email.required :
          validationMessages.email.email }}
        </mat-error>
      </mat-form-field>

      <div class="details page-sub-header" i18n>Additional Details</div>

      <mat-form-field class="mb-3" appearance="outline">
        <mat-label i18n>Payment Method</mat-label>
        <mat-select formControlName="contactType" [placeholder]="paymentMethod">
          @for (method of paymentmethod; track method.id) {
          <mat-option [value]="method.code">
            {{ method.description }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      
      <div class="mb-3 form-field">
        <div class="textarea-wrapper">
          <textarea #noteTextarea id="note" placeholder="{{notePlaceholder}}" required formControlName="note"
            maxlength="200" (input)="autoResize()" aria-label="Note"></textarea>
          <label for="note" i18n class="floating-label">Note (if any)</label>
          <button type="button" class="clear-note-btn" title="Clear note" aria-label="Clear note"
            [hidden]="noteLength === 0" (click)="clearNote()">&times;</button>
        </div>
        <div class="char-counter">{{ noteLength }}/200</div>
      </div>

      <section #consentSection class="example-section">
        <mat-checkbox formControlName="consent" i18n>
          <span class="page-content" >
            The content of this message describes that the customer consents their data to be used for business purpose
          </span>
          <span class="required-asterisk" aria-hidden="true">*</span>
        </mat-checkbox>

        @if ((customerInfoForm.get('consent')?.touched || formSubmitted)
        && customerInfoForm.get('consent')?.errors?.['required']) {
        <div class="error-message">
          <mat-icon color="warn">error</mat-icon>
          {{ validationMessages.consent.required }}
        </div>
        }
      </section>

    </form>
  </div>
</div>